var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9727a0209c1916244293fb76dd805c58fe3150cb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kikushiru@inditidual"]={id:"9727a0209c1916244293fb76dd805c58fe3150cb"};
      